module.exports = __webpack_public_path__ + "static/media/d3ru.fb0fa37d.pdf";